import React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import Marquee from 'react-fast-marquee';
import './index.css';
import {router} from './router';
import {HandleCypress} from './components/Handlers/HandleCypress';
import {HandleAuthAndState} from './components/Handlers/HandleAuthAndState';
import {ASCIIArt} from './components/ASCIIArt';

const style = {
	desktop: `hidden   minimum:flex flex-col   relative   w-full min-h-screen   font-whirlwindPrimary text-whirlwindLightest   bg-whirlwindDarkest`,
	mobile: `minimum:hidden   flex flex-col   w-full min-h-screen   font-whirlwindPrimary text-whirlwindLightest   bg-whirlwindDarkest`,
	mobileMarquee: `pb-4   text-whirlwindPrimaryLight`,
	mobileMessage: `flex flex-grow justify-center items-center   p-4   text-center`,
};

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
);
root.render(
	<React.StrictMode>
		<div className={style.desktop}>
			<HandleCypress />
			<HandleAuthAndState />
			<RouterProvider router={router} />
		</div>
		<div className={style.mobile}>
			<div
				className={style.mobileMessage}
				data-test-id={`mobileMessage_TEST`}>
				Please use a desktop device or wide enough screen :)
			</div>
			<Marquee className={style.mobileMarquee} play={true} speed={20}>
				<ASCIIArt
					dataTestId={`mobileMarquee`}
					tailwindcss
					text={`whirlwind   whirlwind   whirlwind   whirlwind   whirlwind   whirlwind   `}
				/>
			</Marquee>
		</div>
	</React.StrictMode>,
);
